module.exports = __webpack_public_path__ + "static/855e148d8a4611177f32a84cda8c91d1f4dfc5035bc22d46e1e5448e8a6891c6-ccd3b7e9cb6220be9ba86fb283afc573.jpeg";